/* eslint-disable */
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ProductChangelogCreateItemMultipartBody } from '../dto/product-changelog-create-item-multipart-body';

export interface PostProductChangelogCreateItemParams {
  body: ProductChangelogCreateItemMultipartBody;
}

export function httpPostProductChangelogCreateItem(http: HttpClient, data: PostProductChangelogCreateItemParams, options?: { reportProgress?: boolean; observe?: 'body' }): Observable<void>;
export function httpPostProductChangelogCreateItem(http: HttpClient, data: PostProductChangelogCreateItemParams, options?: { reportProgress?: boolean; observe?: 'events' }): Observable<HttpEvent<void>>;
export function httpPostProductChangelogCreateItem(http: HttpClient, data: PostProductChangelogCreateItemParams, options: { reportProgress?: boolean; observe?: 'body' | 'events' } = {}): Observable<any> {
  const body = data.body;
  const form = new FormData();
  if (body.changelogId != null) {
    form.append('ChangelogId', body.changelogId as unknown as string);
  }
  if (body.type != null) {
    form.append('Type', body.type as unknown as string);
  }
  if (body.contentPerLanguage != null) {
    body.contentPerLanguage.forEach((obj,idx) => {
          form.append(`ContentPerLanguage[${idx}].languageCode`, obj.languageCode as unknown as string);
          form.append(`ContentPerLanguage[${idx}].title`, obj.title as unknown as string);
          if (obj.description !== null) form.append(`ContentPerLanguage[${idx}].description`, obj.description! as unknown as string);
          if (obj.file !== null) form.append(`ContentPerLanguage[${idx}].file`, obj.file! as unknown as string);
        });
  }
  return http.post<void>(`{placeholder}/ProductChangelog/CreateItem`, form, options as any);
};

export const urlPostProductChangelogCreateItem = (baseUrl: string, data: PostProductChangelogCreateItemParams) => {
  return `${baseUrl}/ProductChangelog/CreateItem`;
};
